import { CollapseSection } from '@alfa-retail-react/components';
import React from 'react';

import { ProductDetails } from 'app/logic/product/ProductDetails';
import { ConfirmationPageStore } from 'app/logic/pages/confirmation/ConfirmationPageStore';

export interface ProductDetailsFormSectionProps {
    pageStore: ConfirmationPageStore;
}

export const ProductDetailsFormSection = ({
    pageStore,
}: ProductDetailsFormSectionProps) => {
    return (
        <CollapseSection
            className="productDetailsFormSection"
            classNameHeaderWrapper="productDetailsFormSectionHeader"
            header="Выбранные параметры кредита"
        >
            <ProductDetails
                cardProduct={pageStore.cardProduct}
                order={pageStore.order}
            />
        </CollapseSection>
    );
};
